module.exports = __webpack_public_path__ + "img/icon-menu-map.40854145.svg";